<template>
  <div class="relative">
    <div
      class="absolute h-full w-full translate-x-[0.008em] translate-y-[0.12em] !text-navy [&_*]:!text-navy"
    >
      <slot />
    </div>
    <span
      :style="{
        '-webkit-text-stroke-width': '0.016em',
        '-webkit-text-stroke-color': 'rgb(var(--color-navy))',
      }"
      class="relative"
    >
      <slot />
    </span>
  </div>
</template>
